import * as yup from 'yup'

export const schema = yup
  .object()
  .shape({
    name: yup.string().required('Nome é obrigatório!'),
    password: yup
      .string()
      .min(6, 'Senha precisa de no minimo 6 carctere!')
      .required('Nome é obrigatório!'),
    confirmPassword: yup
      .string()
      .required('Confirme a sua senha!')
      .test('passwords-match', 'Senha não confrere', function (value) {
        return this.parent.password === value
      }),
  })
  .required()

export type FieldLogin = yup.InferType<typeof schema>
